import { withAsyncLoading } from '../../../../Components/Templates/Loading/AsyncPageLoading/withAsyncPageLoading';

const LoadableCompagnonDetailsPage = withAsyncLoading(async () =>
    import('./CompagnonDetailsPage').then((res) => res.CompagnonDetailsPage)
);

export { LoadableCompagnonDetailsPage };
